// extracted by mini-css-extract-plugin
export default {"toast":"App_toast__t-Iuz"};